import { sendGet, sendPost, sendDelete } from "helpers/axios"

export const getInterviewList = (params) => sendGet(`api/interview/get-list`, params)
export const getLocations = (params) => sendGet(`api/location/get-all`, params)
export const cancelInterview = (params) => sendDelete(`api/interview/delete`, params)
export const saveInterview = (params) => sendPost(`api/interview/findMeetingTimes`, params);
export const getInterviewers = (params) => sendGet(`api/interview/get-interviewers`, params)